// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { BaseFibonacciDataCacheTool } from "./BaseFibonacciDataCacheTool.js";

export let FibonacciTimeZoneDataCacheTool = function ()
{
    BaseFibonacciDataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.FibonacciTimeZone;
    this.InitPoints(1);
};

FibonacciTimeZoneDataCacheTool.prototype = Object.create(BaseFibonacciDataCacheTool.prototype);

FibonacciTimeZoneDataCacheTool.prototype.InitBlock = function ()
{
    BaseFibonacciDataCacheTool.prototype.InitBlock.apply(this);
    this.fibLevel = [ 0, 1, 2, 3, 5, 8, 13, 21, 34 ];
};

FibonacciTimeZoneDataCacheTool.prototype.MaxPointsCount = function () { return 1; };
FibonacciTimeZoneDataCacheTool.prototype.MinPointsCount = function () { return 1; };

//#region ICaller

/*
public override System.Collections.ArrayList Properties
{
    get
    {
        DynProperty prop = null;
        var props = base.Properties;
        if (Points != null)
        {
            // #30348
            for (int i = 0; i < Points.Length; i++)
            {
                prop = DynProperty.getPropertyByName(props, "Y" + i);
                if (prop != null)
                    prop.EnableEditVariant = true;
            }
        }

        return props;
    }
}
*/

//#endregion